export const THEMES = {
  "stand-with-ua": {
    name: "Stand With 🇺🇦",
    light: false,
    highlights: {
      background: "#183752",
      text: "#bbd5ed",
      variable: "#e5dcb4",
      attribute: "#86b7fc",
      definition: "#ebf3ff",
      keyword: "#e5ce5c",
      operator: "#e5dcb4",
      property: "#86b7fc",
      number: "#e5ce5c",
      string: "#e5dcb4",
      comment: "#5c7a9c",
      meta: "#bbd5ed",
      tag: "#e6e0d3",
    },
  },
  dracula: {
    name: "Dracula",
    light: false,
    highlights: {
      background: "#282a36",
      text: "#f8f8f2",
      variable: "#fff",
      attribute: "#50fa7b",
      definition: "#50fa7b",
      keyword: "#ff79c6",
      operator: "#ff79c6",
      property: "#66d9ef",
      number: "#bd93f9",
      string: "#f1fa8c",
      comment: "#6272a4",
      meta: "#f8f8f2",
      tag: "#ff79c6",
    },
  },
  "duotone-light": {
    name: "Duotone ☀",
    light: true,
    highlights: {
      background: "#faf8f5",
      muted: "#e1ddd3",
      text: "#2d1f03",
      variable: "#b3985e",
      attribute: "#8c6b20",
      definition: "#738fcb",
      keyword: "#8a681c",
      operator: "#8a681c",
      property: "#b3985e",
      number: "#738fcb",
      string: "#022e8b",
      comment: "#adb1b7",
      meta: "#555",
      tag: "#2d1f03",
    },
  },
  "duotone-dark": {
    name: "Duotone ☾",
    light: false,
    highlights: {
      background: "#2a2734",
      text: "#afa7d4",
      variable: "#ffcc99",
      attribute: "#9a86fd",
      definition: "#eeebff",
      keyword: "#ffcc99",
      operator: "#ffad5c",
      property: "#9a86fd",
      number: "#ffcc99",
      string: "#ffb870",
      comment: "#6c6783",
      meta: "#afa7d4",
      tag: "#eeebff",
    },
  },
  material: {
    name: "Material",
    light: false,
    highlights: {
      background: "#263238",
      text: "rgba(233, 237, 237, 1)",
      variable: "#80CBC4",
      attribute: "#FFCB6B",
      definition: "rgba(233, 237, 237, 1)",
      keyword: "rgba(199, 146, 234, 1)",
      operator: "rgba(233, 237, 237, 1)",
      property: "#80CBAE",
      number: "#F77669",
      string: "#C3E88D",
      comment: "#546E7A",
      meta: "#80CBC4",
      tag: "rgba(255, 83, 112, 1)",
    },
  },
  monokai: {
    name: "Monokai",
    light: false,
    highlights: {
      background: "#272822",
      text: "#f8f8f2",
      variable: "#9effff",
      attribute: "#a6e22e",
      definition: "#fd971f",
      keyword: "#f92672",
      operator: "#fff",
      property: "#a6e22e",
      number: "#ae81ff",
      string: "#e6db74",
      comment: "#75715e",
      meta: "#555",
      tag: "#bc6283",
    },
  },
  "night-owl": {
    name: "Night Owl",
    light: false,
    highlights: {
      background: "#011627",
      text: "#abb2bf",
      variable: "#82AAFF",
      attribute: "#F78C6C",
      definition: "#82AAFF",
      keyword: "#c792ea",
      operator: "#c792ea",
      property: "#fff",
      number: "#F78C6C",
      string: "#ecc48d",
      comment: "#717a8a",
      meta: "#7fdbca",
      tag: "#7fdbca",
    },
  },
  nord: {
    name: "Nord",
    light: false,
    highlights: {
      background: "#2e3440",
      text: "#d8dee9",
      variable: "#88C0D0",
      attribute: "#8FBCBB",
      definition: "#D8DEE9",
      keyword: "#81A1C1",
      operator: "#81A1C1",
      property: "#D8DEE9",
      number: "#B48EAD",
      string: "#A3BE8C",
      comment: "#4C566A",
      meta: "#81A1C1",
      tag: "#81A1C1",
    },
  },
  "one-light": {
    name: "One Light",
    light: true,
    highlights: {
      background: "#fafafa",
      muted: "#dbdbdc",
      text: "#383a42",
      variable: "#e06c75",
      attribute: "#d19a66",
      definition: "#4078f2",
      keyword: "#a626a4",
      operator: "#0184bc",
      property: "#4078f2",
      number: "#986801",
      string: "#50a14f",
      comment: "#a0a1a7",
      meta: "#383a42",
      tag: "#e45649",
    },
  },
  "one-dark": {
    name: "One Dark",
    light: false,
    highlights: {
      background: "#282c34",
      text: "#abb2bf",
      variable: "#e06c75",
      attribute: "#d19a66",
      definition: "#e5c07b",
      keyword: "#c678dd",
      operator: "#56b6c2",
      property: "#56b6c2",
      number: "#d19a66",
      string: "#98c379",
      comment: "#5c6370",
      meta: "#abb2bf",
      tag: "#e06c75",
    },
  },
  "solarized-dark": {
    name: "Solarized ☾",
    light: false,
    highlights: {
      background: "#002b36",
      text: "#839496",
      variable: "#b58900",
      attribute: "#2aa198",
      definition: "#2aa198",
      keyword: "#cb4b16",
      operator: "#6c71c4",
      property: "#2aa198",
      number: "#d33682",
      string: "#859900",
      comment: "#586e75",
      meta: "#859900",
      tag: "#93a1a1",
    },
  },
  "solarized-light": {
    name: "Solarized ☀",
    light: true,
    highlights: {
      background: "#fdf6e3",
      muted: "#eee8d5",
      text: "#073642",
      variable: "#839496",
      attribute: "#2aa198",
      definition: "#2aa198",
      keyword: "#cb4b16",
      operator: "#6c71c4",
      property: "#2aa198",
      number: "#d33682",
      string: "#859900",
      comment: "#586e75",
      meta: "#859900",
      tag: "#93a1a1",
    },
  },
  vscode: {
    name: "VSCode",
    light: false,
    highlights: {
      background: "#1E1E1E",
      text: "#D4D4D4",
      variable: "#9CDCFE",
      attribute: "#d19a66",
      definition: "#DCDCAA",
      keyword: "#C586C0",
      operator: "#D4D4D4",
      property: "#DCDCAA",
      number: "#B5CEA8",
      string: "#CE9178",
      comment: "#808080",
      meta: "#D4D4D4",
      tag: "#569cd6",
    },
  },
  "winter-light": {
    name: "Winter Is Coming ☀",
    light: true,
    highlights: {
      background: "#fff",
      text: "#012339",
      variable: "#2f86d2",
      attribute: "#a44185",
      definition: "#367b42",
      keyword: "#236ebf",
      operator: "#a44185",
      property: "#367b42",
      number: "#174781",
      string: "#a44185",
      comment: "#174781",
      meta: "#555",
      tag: "#a44185",
      muted: "#e0ecf1",
    },
  },
  "winter-dark": {
    name: "Winter Is Coming ☾",
    light: false,
    highlights: {
      background: "#001627",
      text: "#d5deeb",
      variable: "#87aff3",
      attribute: "#c792eb",
      definition: "#87aff3",
      keyword: "#00bff8",
      operator: "#00bff8",
      property: "#7fdbca",
      number: "#8cec94",
      string: "#bdf0c0",
      comment: "#999",
      meta: "#555",
      tag: "#bf3cca",
    },
  },
} as const;
